module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__logobar"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "http://www.barnatasa.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "4rem"
    },
    attrs: {
      "src": require("../assets/img/bt_logo_tr.png"),
      "alt": "BARNA-TASA"
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://www.bde.es/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "6rem"
    },
    attrs: {
      "src": require("../assets/img/logo_bde.png"),
      "alt": "BDE"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66676ebf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoBar.vue
// module id = 2157
// module chunks = 0